module.exports = __webpack_public_path__ + "8ac28d18f4a098c7d58e1ab5e8583cde.MP3";